import {SxProps, Theme} from '@mui/material';
import {actionButtonSx} from 'src/components/common/actionButton.sx';

/** Beside the other page actions now, not stacked under a card, so it sizes to its label. */
export const changePlanBtn: SxProps<Theme> = actionButtonSx('32px', 'secondary');

export const archiveButtonSx: SxProps<Theme> = actionButtonSx('32px', 'danger');
